import { Divider } from 'antd';

export const VerticalDivider = () => {
  return (
    <Divider
      type='vertical'
      style={{ borderInlineStartWidth: 4 }}
    />
  );
};